import React, { useRef, useState } from "react";
import { AiFillEye, AiFillEyeInvisible, AiOutlineMinus } from "react-icons/ai";
import { BsFillInfoCircleFill } from "react-icons/bs";



const InputTag = ({
  label,
  length,
  name,
  defaultValue,
  type,
  multiple,
  required,
  disabled,
  info,
  pattern,
}) => {
  const [visibility, setVisibility] = useState(true);
  const [inputType, setInputType] = useState(type);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const inputRef = useRef();
  // let newRR = defaultValue;

  const handleDelete = () => {
    setVisibility(false);
  };

 
  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end w-full" : "hidden"}
    >
      <div className="w-full">
        <label htmlFor={name} className="label capitalize">
          <span className="text-md font-semibold">
            {multiple && length ? label + " " + length : label}
          </span>
          {required && <span className="text-red-500 text-lg">*</span>}
        </label>
        {info && (
          <span>
            <BsFillInfoCircleFill
              id="my-anchor-element-id"
              data-tooltip-delay-show={50}
              className="inline ml-2 mb-1 text-gray-700 text-sm cursor-pointer"
            />
          </span>
        )}
        <div className="relative">
          <input
            name={visibility ? name : ""}
            defaultValue={defaultValue}
            type={inputType}
            className="w-full my-2 border border-gray-300 rounded-md px-3 py-2 z-0"
            required={required}
            disabled={disabled}
            id={name}
            ref={inputRef}
            pattern={pattern ? pattern : null}
          />
          {/* {type === "password" && (
            <>
              {!passwordVisibility ? (
                <button
                  onClick={() => togglePassword("text")}
                  className="absolute right-4 top-5"
                >
                  <AiFillEye className="text-xl text-gray-500" />
                </button>
              ) : (
                <button
                  onClick={() => togglePassword("password")}
                  className="absolute right-4 top-5"
                >
                  <AiFillEyeInvisible className="text-xl text-gray-500" />
                </button>
              )}
            </>
          )} */}
        </div>
      </div>
      <div className={!multiple ? "hidden" : ""}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn btn-sm btn-circle hover:bg-gray-50 border border-gray-400 mb-2 p-2 rounded-full"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default InputTag;
